<tmo-carousel
  [interval]="nextPhotoInterval"
  [loop]="noLoopSlides"
  [itemsToShow]="itemsToDisplay"
  [autoPlay]="autoPlayCarousel"
  *ngIf="showMarketCarousel"
>
  <div class="carousel-inner">
    <div class="carousel-row carousel-section">
      <tmo-slide *ngFor="let slidez of slides" [active]="slidez.active">
        <div class="row">
          <div
            class="col-12 col-md-6 img-panel left-side"
            *ngIf="deviceType === textConst.DEVICE_DESKTOP"
          >
            <img class="img-fluid" [src]="slidez.carouselImageDesktop" alt="FPO Image" />
          </div>
          <div
            class="col-12 col-md-6 img-panel left-side"
            *ngIf="deviceType === textConst.DEVICE_TABLET"
          >
            <img class="img-fluid" [src]="slidez.carouselImageTablet" alt="FPO Image" />
          </div>
          <div
            class="col-12 col-md-6 img-panel left-side"
            *ngIf="deviceType === textConst.DEVICE_MOBILE"
          >
            <img class="img-fluid" [src]="slidez.carouselImageMobile" alt="FPO Image" />
          </div>
          <div class="col-12 col-md-6 text-start right-side text-panel">
            <div [innerHtml]="slidez.promoText"></div>
            <div [innerHtml]="slidez.headerText"></div>
            <div
              class="m-t-md"
              [attr.aria-label]="slidez.bodyText"
              [innerHtml]="slidez.bodyText"
            ></div>
            <div *ngFor="let cta of slidez.ctas; let ind = index">
              <p class="m-t-sm">
                <a
                  *ngIf="cta.type === textConst.LINK && cta.target === 'true'"
                  href="{{ cta.link }}"
                  target="_blank"
                  id="cta-default-741_{{ ind }}"
                  rel="noopener"
                  >{{ cta.text }}</a
                >
                <a
                  *ngIf="cta.type === textConst.LINK && cta.target === 'false'"
                  href="{{ cta.link }}"
                  id="cta-default-742_{{ ind }}"
                  >{{ cta.text }}</a
                >
                <a
                  *ngIf="cta.type === textConst.BUTTON && cta.target === 'true'"
                  href="{{ cta.link }}"
                  target="_blank"
                  class="btn btn-primary"
                  id="cta-default-743_{{ ind }}"
                  rel="noopener"
                  >{{ cta.text }}</a
                >
                <a
                  *ngIf="cta.type === textConst.BUTTON && cta.target === 'false'"
                  href="{{ cta.link }}"
                  class="btn btn-primary"
                  id="cta-default-744_{{ ind }}"
                  >{{ cta.text }}</a
                >
              </p>
            </div>
            <div [attr.aria-label]="slidez.disclaimerText" class="legal m-t-lg">
              {{ slidez.disclaimerText }}
            </div>
          </div>
        </div>
      </tmo-slide>
    </div>
  </div>
</tmo-carousel>
